import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatOptionModule } from '@angular/material/core';



import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { ProductTplService } from '@app/sales/product-tpl/productTpl.service';
import { CommonService } from '@app/common/common.service';
import { ValuesService } from '@app/common/values/values.service';
import { LoginService } from '@app/common/login.service';
import { AttachService } from '@app/shared/attach/attach.service';
import { SpinnerService } from '@app/shared/spinner.service';
import { AlertService } from '@app/shared/alert.service';
import { AttributesComponent } from './attributes/attributes.component';
import { ProductTplGeneralComponent } from './product-tpl-general/product-tpl-general.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PartnerComponent } from '@app/common/partner/partner.component';

import { VariantsButtonComponent } from '../../shared/action-bar/variants-button/variants-button.component';
import { ProductButtonComponent } from '../../shared/action-bar/product-button/product-button.component';
import { ActionBarComponent } from '@app/shared/action-bar/action-bar.component';
import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';
import { CufComponent } from '@app/shared/cuf/cuf.component';
import * as common from '@app/shared/_models/common';
// import { Partner } from '@app/shared/_models/common'
import { SearchPartnerComponent } from '@app/shared/search-partner/search-partner.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {   ProductAttributeVal, ProductAttribute , TreeNodeDecl, Product } from '@app/shared/_models/product';
import { TreeNode } from '@app/shared/_models/common';

import { SmartInputComponent } from '@app/shared/smart-input/smart-input.component'
import { ImageViewerDialogComponent } from '@app/shared/attach/image-viewer-dialog/image-viewer-dialog.component';

import { TreeComponent } from './tree/tree.component';
import { TreeNodeDeclComponent} from './tree-decl/tree-node-decl.component';

import { MatDialogModule } from '@angular/material/dialog';

import { ImageCarouselComponent } from '../../shared/attach/image-carousel/image-carousel.component';
import { subscribe } from 'diagnostics_channel';
import {ObjectType, EventType, C_VALUES_UOM, C_COMPONENT_VARIANT, PARTNER_ROLE_MANUFACTURER } from "@app/shared/constants";
@Component({
    selector: 'app-product-tpl',
    templateUrl: './productTpl.component.html',
    styleUrls: ['./productTpl.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SmartInputComponent, ImageCarouselComponent, MenuCommonComponent, MatButtonModule, TreeNodeDeclComponent, MatIconModule, MatDialogModule, TreeComponent, SearchPartnerComponent, MatSelectModule, MatOptionModule, CufComponent, FormsModule, ReactiveFormsModule, ActionBarComponent, VariantsButtonComponent, ProductButtonComponent, MatFormFieldModule, MatInputModule, MatTabsModule, ProductTplGeneralComponent, AttributesComponent]
})
export class ProductTplComponent {
	constructor(public loginService: LoginService, private attachService:AttachService,  private valuesService: ValuesService, public dialog: MatDialog, private route: ActivatedRoute, private location: Location, private commonService: CommonService, private productTplService: ProductTplService, private router: Router, private fb: FormBuilder, private spinner: SpinnerService, private alertService: AlertService) { }

	public dataSource: MatTableDataSource<AbstractControl> = new MatTableDataSource();
	readonly ROLE_MANUFACTURER = PARTNER_ROLE_MANUFACTURER;	// rôle du sélecteur « search-fab » (c_values 2, négatif depuis le 2026-09-15)
	public template_id:number = 0;
	public creationKind: 'flat' | 'generic' = 'generic';	// ce qu'on est venu créer (query param `kind`)
	public formGroup!: FormGroup;
	public loadProductTplEventsSubject: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(this.formGroup);		// To emit load productTpl event
	public oldformGroup!: FormGroup;	// Initial values to store in event 
	public eventtyp:number = EventType.INSERT;			// Insert event by default
  public salesUnit:any;
	public vat :any[] = [];

	private subs: Subscription[] = [];
	public cufsStructure : common.Cuf[] =[]

  public tree! : common.TreeNode ;
    // Ensemble partagé vers les enfants récursifs
  public selectedTreeNode = new Set<TreeNode>();

  public imageUrlsMap = new Map<number, string>();
  public attachs_images : common.Attach[] = [];

	loadEventsSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);	// Warning. BehaviorSubject needs to emit an initial value. A flag indicated a true reloading


  onSelectedChange(selectedTreeNode : Set<TreeNode>) {
    console.log('begining selectedTreeNode',selectedTreeNode);
    this.selectedTreeNode = selectedTreeNode;

    this.formGroup.setControl('lnk_treenodes', new FormArray(
      Array.from(selectedTreeNode).map((tn: TreeNode) => TreeNode.asFormGroup(tn))
    ));

    console.log('end selectedTreeNode',selectedTreeNode);
  }
  // get selectedIds(): number[] {
  //   return Array.from(this.selected.values());
  // }
  
	ngOnInit(): void {
		this.template_id = Number(this.route.snapshot.paramMap.get('id'));
		// « flat » = produit à plat, « generic » = modèle générique : le serveur crée le MÊME couple
		// (process_template_insert), seule la SUITE diffère — voir onSubmit.
		this.creationKind = this.route.snapshot.queryParamMap.get('kind') === 'flat' ? 'flat' : 'generic';
		this.subs.push(
      this.commonService.getCufs(C_COMPONENT_VARIANT).subscribe((cufsStructure: common.Cuf[]) => this.cufsStructure = cufsStructure),
      this.valuesService.getValues$(C_VALUES_UOM).subscribe((data: any) => { this.salesUnit = data.sort((a: any, b: any) => a.name.localeCompare(b.name)); }),
      this.commonService.getTaxes().subscribe((data: any) => { this.vat = data; }),
      this.commonService.getTree('princ', 0).subscribe((items: common.ITreeNode[]) => {
        this.tree = new common.TreeNode({ id: 0, seq: 0, name: 'Root', label: 'Root', path: '', nlevel: 0, typ: 0, children: [] });
        items.sort((a, b) => a.path.length - b.path.length);
        items.forEach(item => {
          this.tree.getNodeByPath(item.path.split('.').slice(0, -1))?.children.push(new common.TreeNode(item));
        });
      }),
    );
    
		
		if (this.template_id === 0) {	// New template (no URL param)
			console.log("New template ");
			this.formGroup = this.fb.group({
				id: new FormControl<number>(+0),
				name: new FormControl<String>(""),
				manuf: new FormControl<number|undefined>(undefined),
				baseuom: new FormControl<any>(undefined),
				unitpriceuom: new FormControl<any>(undefined),
				vat: new FormControl<number>(+1),
				has_variants: new FormControl<boolean>(false),
				unique_variant: new FormControl<number|undefined>(undefined),
        // lnk_memos: new FormArray([Memo.asFormGroup({ content: '' , objecttyp: constants.OBJECTTYP_TEMPLATE } as Memo)]),
        lnk_treenodes : new FormArray([]),
        // lnk_attach_default_memo: common.Attach.asFormGroup({ memo:'', objecttyp: constants.OBJECTTYP_TEMPLATE, objectid: this.template_id, userid:6, datcre: new Date(),  data:{flags:["is_default_memo" ]}} as common.Attach  ),
				// memo: new FormControl<String|undefined>(undefined),
			});
			this.oldformGroup = this.fb.group({
				id: new FormControl<number>(+0),
				name: new FormControl<String>(""),
				manuf: new FormControl<number|undefined>(undefined),
				baseuom: new FormControl<any>(undefined),
				unitpriceuom: new FormControl<any>(undefined),
				vat: new FormControl<number>(+1),
				has_variants: new FormControl<boolean>(false),
				unique_variant: new FormControl<number|undefined>(undefined),
        // lnk_memos: new FormArray([Memo.asFormGroup({ content: '', objecttyp: constants.OBJECTTYP_TEMPLATE } as Memo)]),
        // lnk_attach_default_memo: common.Attach.asFormGroup({ memo:'', objecttyp: constants.OBJECTTYP_TEMPLATE, objectid: this.template_id, userid:6, datcre: new Date(),  data:{flags:["is_default_memo" ]}} as common.Attach  ),
        lnk_treenodes : new FormArray([])
				// memo: new FormControl<String|undefined>(undefined),

			});			
		} else {	// Load existing template
			// console.log("Load existing template");
			this.loadTemplate();
		}
    
    this.subs.push ( this.router.events.subscribe((event : any) => {
      if (event instanceof NavigationEnd && this.template_id !==0) {	// Real reload, not a F5 on same page
        console.log("NavigationEnd, reloading");
        this.loadTemplate();
      }
    }));
    	
	}
	
	private loadTemplate() {
    // console.log('loadTemplate');
		// this.spinner.show();
		this.eventtyp = EventType.UPDATE; 										// Update mode. Will issue an update event
    this.subs.push( this.productTplService.getTemplateAsFormGroup(this.template_id)
			.subscribe((data: FormGroup) => {
        // console.log(' after subscribe data.getRawValue()',data.getRawValue());

				if (this.formGroup) {			// After submit, formgroup exists => patch  // a cause des form array on utilise plus patchValue ce qui est pas bien
          this.formGroup = data;
					// console.log("Patching data: " + JSON.stringify(data.getRawValue()));
				} else {	// First formgroup setting. No previous value
					this.formGroup = data;
				}

        if (this.formGroup?.value?.lnk_attachs) {
          // this.attachService.ensureDefaultMemo(this.formGroup.get('lnk_attachs') as FormArray,  constants.OBJECTTYP_TEMPLATE, this.template_id);
          
          const hasMemo = (this.formGroup.get('lnk_attachs') as FormArray).value.some((a: any) => a.data?.['flags']?.includes('is_default_memo'));
          if (!hasMemo) {
            const newMemo = this.attachService.getDefaultMemo(ObjectType.TEMPLATE, this.template_id);
            (this.formGroup.get('lnk_attachs') as FormArray).push(newMemo);
          }
          // this.attachService.syncAttachImages(this.formGroup.value.lnk_attachs, this.attachs_images);
          this.attachs_images = this.attachService.generate_attachs_object_with_thumbnail(this.formGroup.value.lnk_attachs);

        }
				this.oldformGroup = data;						// Save loaded value
        this.selectedTreeNode = data.value.lnk_treenodes ? new Set<TreeNode>(data.value.lnk_treenodes) : new Set<TreeNode>()  // Initialisation de
				this.loadEventsSubject.next(true);	// Emit a load event to child component
        this.loadProductTplEventsSubject.next(this.formGroup);
        console.log('this.formGroup.value',this.formGroup.value);
			}));
	}

  get lnk_memos(): FormArray {
    return this.formGroup.get('lnk_memos') as FormArray;
  }
  // <app-tree  *ngIf="(tree?.children?.length ?? 0) > 0"   [tree]="tree.children[0]"   [selected]="selectedTreeNode"   (selectedChange)="onSelectedChange($event)" ></app-tree>
  openTreeDialog(): void {
    this.dialog.open(TreeComponent, {
      data: {
        tree: this.tree.children[0],
        selected: this.selectedTreeNode,
        selectedChange: (selected: Set<TreeNode>) => this.onSelectedChange(selected)
      },
      width: '600px',
    });
  }



  /** Gestion unifiée upload fichier ou vidéo YouTube — même pattern placeholder/completed */
  private handleMediaUpload(upload$: Observable<any>): void {
    upload$.subscribe({
      next: (response: any) => {
        if (response?.status === 'placeholder' && response?.item) {
          this.attachs_images.push(response.item);
        } else if (response?.status === 'completed' && response?.item) {
          const idx = this.attachs_images.findIndex(a => a.seq === response.item.seq);
          if (idx !== -1) {
            this.attachs_images[idx] = response.item;

            const sub = this.attachService.loadThumbnailImage$(response.item).subscribe(blob => {
              this.attachs_images[idx].thumbnailLocalUrl = URL.createObjectURL(blob);
              sub.unsubscribe();
            });
          }
        }
      },
      error: (error: any) => console.error('Request failed', error)
    });
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;
    this.handleMediaUpload(
      this.attachService.uploadMediaWithPlaceholder$(file, ObjectType.TEMPLATE, this.template_id, this.attachs_images)
    );
  }

  uploadYoutubeVideo(youtubeUrl: string): void {
    if (!youtubeUrl?.trim()) return;
    this.handleMediaUpload(
      this.attachService.uploadYoutubeWithPlaceholder$(youtubeUrl, ObjectType.TEMPLATE, this.template_id, this.attachs_images)
    );
  }



  // loadImagetest() {
  //   this.commonService.loadImage$(17).subscribe(blob => {
  //     // Créer une URL qui pointe directement vers le blob en mémoire
  //     this.imageUrl = URL.createObjectURL(blob);
  //   });

  // }




  public updateProductAttributeValues(event:any) {
    console.log('event',event);
    this.router.navigate(['/sales/product-tpl/' + this.template_id]);	// Reload Template
  }
	
	public updateProductAttributes(event:any) {
    console.log('event',event);
		// this.formGroup.get("has_variants")?.patchValue(hasVariants);
	}	
	
	getCufGroupe(): FormGroup{
		if(this.formGroup && (this.formGroup ).get('data') && ((this.formGroup ).get('data') as FormGroup).get('cufs') ){
			return (((this.formGroup ).get('data') as FormGroup)  .get('cufs') as FormGroup) 
		} else {
			return this.formGroup
		}
	}

  get defaultMemoControl(): FormControl | null {
    const lnk_Attachs = this.formGroup.get('lnk_attachs') as FormArray;
    const index = lnk_Attachs.controls.findIndex((ctrl) => {
      const data = ctrl.get('data')?.value;
      return data?.flags?.includes('is_default_memo');
    });
    if (index === -1) return null;
    return lnk_Attachs.at(index).get('memo') as FormControl;
  }

  get defaultImage(): common.Attach | null {
    return this.attachs_images.find((attach: common.Attach) => {
      return Array.isArray(attach.data?.['flags']) && attach.data?.['flags'].includes('is_default_image');
    }) || null;
  }



    openPartnerDialog(idpartner: Number ) {
      const dialogRef = this.dialog.open(PartnerComponent, {
        width: '80%',
        height: '80%',
        data: { mode: "DIALOG", "id": idpartner  }
      });
      this.subs.push( dialogRef.afterClosed().subscribe((newpartner) => {	// result could be undefined  after closing dialog we want to update manufacture
        console.log('newpartner',newpartner);
        this.manufactureChange(newpartner);
      }));
    }

  manufactureChange(newManufacture: common.Partner) {
    console.log('newManufacture',newManufacture);
    

    // this.formGroup.get("lnk_partner_manuf")?.patchValue(common.Partner.asFormGroup(newManufacture));
    if (newManufacture && newManufacture.id) {	// If a customer is selected
      this.formGroup.get("manuf")?.patchValue(newManufacture.id);
      this.formGroup.setControl('lnk_partner_manuf',  common.Partner.asFormGroup(newManufacture)     );
      
    } else {
      this.formGroup.setControl('lnk_partner_manuf',  null     );
      this.formGroup.get("manuf")?.patchValue(undefined);	
    }

  }




  onImageClick() {
    console.log('Image defaut cliquée:');
    
    // Trouver l'image correspondante
    // const attach = this.attachs.find(img => img.id === imageId);
    if (!this.defaultImage) {
      console.error('Image par defaut non trouvée pour ');
      return;
    }
    
    // Ouvrir le dialogue avec l'image
    this.dialog.open(ImageViewerDialogComponent, {
      width: '90%',
      maxWidth: '1200px',
      maxHeight: '90vh',
      data: { attach: this.defaultImage },
      panelClass: 'image-viewer-dialog-panel'
    });
  }

  // addSupplier(newSupplier: common.Partner){
  //   console.log('newSupplier',newSupplier);
  //   this.productServiceSubscription = this.productTplService.postAddSupplierToTemplate(newSupplier.id, this.template_id ).subscribe((response: any) => {
	// 	console.log("Server response: " + JSON.stringify(response));
	// 	this.router.navigate(['/sales/product-tpl/' + response.data.template_id]);	// Reload Template
	// });	
  // }
  // removeSupplier(oldSupplier: common.Partner){
  //   console.log('Salut from : inside remove supplier dans productTpl');
  //   this.productServiceSubscription = this.productTplService.postRemoveSupplierToTemplate(oldSupplier.id, this.template_id ).subscribe((response: any) => {
  //     console.log("Server response: " + JSON.stringify(response));
  //     this.router.navigate(['/sales/product-tpl/' + response.data.template_id]);	// Reload Template
  //   });	
  // }

   // ceci est un hot saving
  // TODO Why do we use same call as variant? FIXME old_formgroup param
  public onSubmit(_e:any) {
    console.log("OnSubmit");
    const creating = this.eventtyp === EventType.INSERT;
    this.subs.push( this.productTplService.postProductEvent(this.eventtyp, this.template_id, ObjectType.TEMPLATE, this.oldformGroup, this.formGroup).subscribe({
      next: (response: any) => {
        console.log("Server response: " + JSON.stringify(response));
        if (response?.success === false) { this.alertService.error(response.error_msg || response.msg || 'Enregistrement refusé par le serveur'); return; }
        // Insert comme update rendent {event_id, template_id}, jamais product_id : le lire renvoyait
        // la création sur /sales/product-tpl/0, page vierge.
        const template_id = Number(response?.data?.template_id) || this.template_id;
        if (creating) {
          this.alertService.success(this.creationKind === 'flat' ? 'Produit créé' : 'Modèle créé');
          // Un produit à plat se continue sur sa fiche (prix, conditionnements, références) ;
          // un modèle générique reste ici pour ses attributs puis ses déclinaisons.
          if (this.creationKind === 'flat') { this.gotoUniqueProduct(template_id); return; }
        }
        this.reload( template_id );
      },
      error: (err: any) => {
        // POST /event rend un 500 avec le message en texte brut (event/src/routes.rs) : sans ce
        // bloc, un refus du serveur était muet et l'écran semblait avoir enregistré.
        const msg = typeof err?.error === 'string' ? err.error : (err?.error?.error_msg || err?.error?.msg || err?.message || 'Erreur inconnue');
        console.error("Template save failed:", err);
        this.alertService.error(`Enregistrement du modèle échoué : ${msg}`);
      }
    } ) );
  }

  // La réponse ne porte que l'id du modèle né avec son unique produit : on relit pour trouver celui du produit,
  // et à défaut on reste sur le modèle plutôt que d'échouer en silence.
  private gotoUniqueProduct(template_id: number) {
    this.subs.push( this.productTplService.getTemplate(template_id, []).subscribe({
      next: (rows: any) => {
        const product_id = rows?.[0]?.lnk_products?.[0]?.id;
        if (product_id) { this.router.navigate(['/sales/product/' + product_id]); }
        else { this.reload(template_id); }
      },
      error: () => this.reload(template_id)
    }));
  }

  reload( id : number = 0  ){
  console.log('$event',id);
  if( !id || id ==0 ) { id  =  this.template_id }
  this.router.navigate(['/sales/product-tpl/' + id ]);	// Reload Template
}


	public ngOnDestroy(): void {
		this.subs.forEach(s => s.unsubscribe());
	}	

}
